// src/Components/Common/NumberInput.tsx
// Input số nguyên tự động hiển thị dấu phân cách hàng nghìn (VD: 1.000.000) ngay khi gõ,
// dùng thay cho <Input type="number"> ở các trường số lượng/giá tiền.

import React from 'react';
import { Input } from 'reactstrap';
import type { InputProps } from 'reactstrap';

interface NumberInputProps extends Omit<InputProps, 'type' | 'value' | 'onChange'> {
  value: number | string | null | undefined;
  onChange: (value: number) => void;
}

// Định dạng theo chuẩn Việt Nam (dấu chấm phân cách hàng nghìn) để hiển thị trong ô nhập
const formatGrouped = (value: number | string | null | undefined): string => {
  if (value === null || value === undefined || value === '') return '';
  const numeric = typeof value === 'number' ? value : Number(value);
  if (Number.isNaN(numeric)) return '';
  return numeric.toLocaleString('vi-VN');
};

// Chỉ giữ lại chữ số người dùng gõ, bỏ qua dấu chấm phân cách hàng nghìn tự thêm vào
const parseDigits = (raw: string): number => {
  const digitsOnly = raw.replace(/\D/g, '');
  return digitsOnly === '' ? 0 : Number(digitsOnly);
};

const NumberInput: React.FC<NumberInputProps> = ({ value, onChange, ...rest }) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(parseDigits(e.target.value));
  };

  return (
    <Input
      type="text"
      inputMode="numeric"
      autoComplete="off"
      value={formatGrouped(value)}
      onChange={handleChange}
      {...rest}
    />
  );
};

export default NumberInput;
